import { Component, inject } from '@angular/core';
import { FlashService } from '../../core/services/flash.service';

/** 旧版 <flash-message> 相当。FlashService の通知をこの位置に表示する。 */
@Component({
  selector: 'app-flash-message',
  standalone: true,
  template: `
@for (flash of flashService.flashes(); track flash.id) {
  <div role="alert" class="alert alert-{{ flash.type }}" [class.alert-dismissible]="flash.showClose">
    @if (flash.showClose) {
      <button type="button" class="close" aria-label="通知を閉じる" (click)="flashService.dismiss(flash.id)"><span aria-hidden="true">&times;</span></button>
    }
    <span>{{ flash.text }}</span>
  </div>
}
  `,
})
export class FlashMessageComponent {
  readonly flashService = inject(FlashService);
}
